import {Badge} from '@genestack/ui';
import React from 'react';

import {Preloader} from '../../../../components/preloader/preloader';
import {Sidebar} from '../../../../components/layout/sidebar';
import {useDeletedQueries} from '../hooks/use-deleted-queries';
import {QueryInfoItem} from '../query-info-item';

import styles from './deleted-queries-sidebar.module.css';
import {QueriesSidebarProps} from '../interface';
import {SidebarHeader} from '../../../../components/layout/sidebar/sidebar-header/sidebar-header';
import {EmptyList} from '../../../../components/empty-list/empty-list';

export function DeletedQueriesSidebar(props: QueriesSidebarProps) {
    const deletedQueries = useDeletedQueries();

    const sidebarHeader = React.useMemo(
        () => (
            <SidebarHeader onClose={props.closeSidebar} title="Recycle Bin">
                <Badge
                    ghost
                    className={styles.label}
                    intent="warning"
                    variant="caption"
                    disableTextTransform
                    contentProps={{className: styles.labelContent}}
                >
                    Queries in the Recycle Bin are deleted forever after&nbsp;30&nbsp;days
                </Badge>
            </SidebarHeader>
        ),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    return (
        <Sidebar header={sidebarHeader} border="right">
            <Preloader show={deletedQueries.isLoading}>
                {deletedQueries.data?.length === 0 && <EmptyList message="No queries found" />}

                {deletedQueries.data?.map((queryInfo) => (
                    <QueryInfoItem
                        key={queryInfo.id}
                        queryInfo={queryInfo}
                        isSelected={queryInfo.id === props.queryId}
                        isBookmarkedIcon={queryInfo.shared}
                    />
                ))}
            </Preloader>
        </Sidebar>
    );
}
